import ChatHeader from "./ChatHeader"
import MatchesDisplay from "./MatchesDisplay";
import ChatOwnClothesDisplay from "./ChatOwnClothesDisplay";
import OwnClothesDisplay from "./OwnClothesDisplay";
import InterestedUsersInOwnClothesDisplay from "./InterestedUsersInOwnClothesDisplay";
import {useState} from "react";

import ChatDisplay from "./ChatDisplay"
const ChatContainer = ({user,own_matches}) => {
    const [clickedClothes, setClickedClothes] = useState(null)
    const [clickedOwnClothes, setClickedOwnClothes] = useState(null)
    const [clickedFoundClothesBanner, setClickedFoundClothesBanner] = useState(true)
    const [clickedOwnClothesBanner, setClickedOwnClothesBanner] = useState(false)
    const [clickedUser, setClickedUser] = useState(null)


    const setFoundClickedHome = () =>{
        setClickedClothes(null)
        setClickedOwnClothes(null)
        setClickedFoundClothesBanner(true);
        setClickedOwnClothesBanner(false);
        setClickedUser(null)

    }

    const setClickedOwnClothesHome = () =>{
        setClickedClothes(null)
        setClickedOwnClothes(null)   
        setClickedFoundClothesBanner(false);
        setClickedOwnClothesBanner(true);
        setClickedUser(null)

            
    }


    return(

        <div className="chat-container">

            <ChatHeader user={user}/>

            <div class="menu-options">
                <button className="option foundclothes" onClick={setFoundClickedHome}>Matches</button>
                <button className="option ownclothes" onClick={setClickedOwnClothesHome}>Garderobe</button>
                <button className="option" disabled={(!clickedClothes &&!clickedUser)}>Chat</button>
            </div>
            {!clickedClothes && !clickedOwnClothesBanner && <MatchesDisplay own_matches={own_matches} setClickedClothes={setClickedClothes}/>}
            {clickedClothes && !clickedOwnClothesBanner && (clickedClothes || clickedUser) &&  <ChatDisplay user={user} clickedClothes={clickedClothes}/>}
        
            {!clickedOwnClothes && !clickedFoundClothesBanner && !clickedUser && <OwnClothesDisplay user={user} setClickedOwnClothes={setClickedOwnClothes} />}


            {clickedOwnClothes && !clickedFoundClothesBanner && !clickedUser && <InterestedUsersInOwnClothesDisplay user={user} clickedOwnClothes={clickedOwnClothes} setClickedUser={setClickedUser}/>}
            
            {clickedOwnClothes && clickedOwnClothesBanner && clickedUser && <ChatOwnClothesDisplay user={user} clickedUser={clickedUser} clickedClothes={clickedOwnClothes}/>}


        </div>
    )
}
export default ChatContainer